import { parsePhoneNumberFromString } from "libphonenumber-js";

const formatPhoneNumber = (phoneNumber, deafultCountry = "US") => {
  if (!phoneNumber) return null;

  const parsedPhoneNumber = parsePhoneNumberFromString(
    phoneNumber,
    deafultCountry
  );

  if (parsedPhoneNumber.country === "US") {
    return parsedPhoneNumber.formatNational();
  } else {
    return parsedPhoneNumber.formatInternational();
  }
};
/**
 * Can pass strings, numbers, or objects to this function.
 * propName must be specified if passing an object.
 * @param {*} objA - value or object to be compared
 * @param {*} objB - value or object to be compared
 * @param {string | null} [propName] - property name if objA and objB are objects
 * @returns
 */
const comparatorDesc = (objA, objB, propName = null) => {
  const a = propName ? objA[propName] : objA;
  const b = propName ? objB[propName] : objB;

  return a < b ? 1 : a > b ? -1 : 0;
};

/**
 * @param {*} objA - value or object to be compared
 * @param {*} objB - value or object to be compared
 * @param {string | null} [propName] - property name if objA and objB are objects
 * @returns
 */
const comparatorAsc = (objA, objB, propName = null) => {
  return -1 * comparatorDesc(objA, objB, propName);
};

const groupByProp = (items, key) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item["props"][key]]: [...(result[item["props"][key]] || []), item],
    }),
    {}
  );

/**
 * Takes a list of items and groups them by the keys provided.
 * @param {Array} items - The list to be grouped.
 * @param {Array} keys - The list of property values to group by. These properties can be nested by dot notation.
 * Example: ["props.sellerName", "props.violationCount"]
 * @param {Func} specialFunc - A function to be called on the grouped key. This is useful for special cases like grouping by an individual marketplaceId.
 * @returns
 */
const groupByKeys = (items, keys, specialFunc = () => {}) => {
  return items.reduce((result, item) => {
    let groupedKey = keys.reduce((result, k) => {
      return (result += getNestedProp(item, k));
    }, "");

    groupedKey = specialFunc(item, groupedKey);

    return {
      ...result,
      [groupedKey]: [...(result[groupedKey] || []), item],
    };
  }, {});
};

const getNestedProp = (obj, path) => {
  const pathArray = path.split("."); // Split the path string into an array of keys

  let nestedValue = obj;
  for (const key of pathArray) {
    nestedValue = nestedValue[key];
  }

  return nestedValue;
};

const validateEmail = async (email) => {
  return new Promise((resolve) => {
    if (!email) {
      resolve(null);
      return;
    }

    let emailWorks = false;
    if (
      //https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
      String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      emailWorks = true;
    }
    resolve(emailWorks ? null : `${email} is not a valid email.`);
  });
};

const flattenObject = (obj, prefix = '') => {
  const flattened = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        Object.assign(flattened, flattenObject(obj[key], newKey));
      } else {
        flattened[newKey] = obj[key];
      }
    }
  }

  return flattened;
};

export {
  comparatorAsc,
  comparatorDesc,
  groupByProp,
  groupByKeys,
  getNestedProp,
  validateEmail,
  formatPhoneNumber,
  flattenObject,
};
